import { bridge } from '~/services/bridge'

/**
 * Open a URL externally. In plugin mode, uses bridge to open in host browser.
 * In browser mode, uses window.open.
 */
export function openExternal(url: string) {
  if (bridge.isInPlugin()) {
    bridge.openInBrowser(url)
  } else {
    window.open(url, '_blank')
  }
}
